<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 设置管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="print">
            <div class="handlebox">
                <span class="boxFont">公司信息打印页</span>
            </div>
            <div class="content">
                <div style="width:1500px">
                    <el-form label-width="180px" inline ref="tableData" :model="tableData">
                        <el-form-item label="公司名称" prop="company_name">
                            <span class="red">（打印页）</span>
                            <el-input class="handle-input2" v-model="tableData.company_name"
                                @change="addData(tableData.company_name,'company_name')"></el-input>
                        </el-form-item>
                        <el-form-item label="公司电话" prop="company_phone">
                            <span class="red">（打印页）</span>
                            <el-input class="handle-input2" v-model="tableData.company_phone"
                                @change="addData(tableData.company_phone,'company_phone')"></el-input>
                        </el-form-item>
                        <el-form-item label="客服电话" prop="service_phone">
                            <span class="red">（打印页）</span>
                            <el-input class="handle-input2" v-model="tableData.service_phone"
                                @change="addData(tableData.service_phone,'service_phone')"></el-input>
                        </el-form-item>
                        <el-form-item label="编码" prop="coding">
                            <span class="red">（打印页）</span>
                            <el-input class="handle-input2" v-model="tableData.coding"
                                @change="addData(tableData.coding,'coding')"></el-input>
                        </el-form-item>
                        <el-form-item label="公司地址" prop="company_address">
                            <span class="red">（打印页）</span>
                            <el-input class="handle-input2" v-model="tableData.company_address"
                                @change="addData(tableData.company_address,'company_address')">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="备案登记人" prop="registrar">
                            <span class="red">（打印页）</span>
                            <el-input class="handle-input2" v-model="tableData.registrar"
                                @change="addData(tableData.registrar,'registrar')"></el-input>
                        </el-form-item>
                        <el-form-item label="信息录入人" prop="enter">
                            <span class="red">（打印页）</span>
                            <el-input class="handle-input2" v-model="tableData.enter"
                                @change="addData(tableData.enter,'enter')"></el-input>
                        </el-form-item>
                        <el-form-item label="派出所" prop="police">
                            <span class="red">（打印页）</span>
                            <el-input class="handle-input2" v-model="tableData.police"
                                @change="addData(tableData.police,'police')"></el-input>
                        </el-form-item>
                        <el-form-item label="标题" prop="title">
                            <span class="red">（打印页）</span>
                            <el-input class="handle-input2" v-model="tableData.title"
                                @change="addData(tableData.title,'title')"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

            <!-- <div class="handlebox">
                <span class="boxFont">最低金额限制设置</span>
            </div>
            <div class="content">
                <div style="width:1500px">
                    <el-form label-width="180px" ref="tableData" :model="tableData">
                        <el-form-item label="最低金额">
                            <el-input class="handle-input2" v-model="model"></el-input>
                        </el-form-item>
                    </el-form>
                    <el-button style="margin-left:180px" type="primary" @click="minAmount">保存</el-button>
                </div>
            </div> -->

            <!-- <div class="handlebox">
                <span class="boxFont">管理员接收信息</span>
            </div>
            <div class="content" >
                <div style="width:1500px">

               
                <el-form label-width="180px" ref="tableData" :model="tableData" >
                    <el-form-item label="推送ID" label-width="180px"  prop="admin_id"> 
                        <el-input class="handle-input1" v-model="tableData.admin_id" @change="addData(tableData.admin_id,'admin_id')" ></el-input>
                    </el-form-item>
                    <el-form-item  label="推送管理员" label-width="180px">  
                        <el-table
                            :data="tableManage"
                            border
                            class="table"
                            ref="multipleTable"
                            header-cell-class-name="table-header"
                            @selection-change="handleSelectionChange"
                            style="width:700px"
                        >
                            <el-table-column prop="admin_name" label="管理员" width="150" align="center"></el-table-column>
                            <el-table-column prop="admin_openID" label="openID" width="400" align="center"></el-table-column>
                            <el-table-column label="操作" width="148" align="center">
                            <template slot-scope="scope">
                                <el-button
                                    type="text"
                                    icon="el-icon-delete"
                                    class="red"
                                    @click="deleteManage(scope.$index, scope.row)"
                                >删除</el-button>
                            </template>
                </el-table-column>
                        </el-table>
                    <el-button size="small" @click="addVisiable = true">添加</el-button>
                    </el-form-item>
                  
                </el-form>
                 </div>
            </div>
                <div class="handlebox">
                <span class="boxFont">腾讯识别文字</span>
            </div>
            <div class="content" >
                  <div style="width:1500px">
                <el-form label-width="180px" inline ref="tableData" :model="tableData" >
                    <el-form-item label="腾讯APPID"  prop="appid">
                        <el-input class="handle-input1" v-model="tableData.appid" @change="addData(tableData.appid,'appid')"></el-input>
                    </el-form-item>
                    <el-form-item label="腾讯SecretId"  prop="secretId">
                        <el-input class="handle-input1" v-model="tableData.secretId" @change="addData(tableData.appid,'secretId')"></el-input>
                    </el-form-item>
                    <el-form-item label="腾讯SecretKey"  prop="secretkey">
                        <el-input class="handle-input1" v-model="tableData.secretkey" @change="addData(tableData.appid,'secretkey')"></el-input>
                    </el-form-item>
                   
                </el-form>
                  </div>
            </div>

            <div class="handlebox">
                <span class="boxFont">小程序订单推送模版</span>
            </div>
            <div class="content" >
                  <div style="width:1500px">
                <el-form label-width="180px" inline ref="tableData" :model="tableData" >
                    <el-form-item label="小程序受理推送模版"  prop="program_accept">
                        <el-input class="handle-input1" v-model="tableData.program_accept" @change="addData(tableData.program_accept,'program_accept')" ></el-input>
                    </el-form-item>
                    <el-form-item label="小程序发货推送模版"  prop="program_delivery">
                        <el-input class="handle-input1" v-model="tableData.program_delivery" @change="addData(tableData.program_delivery,'program_delivery')"></el-input></el-input>
                    </el-form-item>
                    <el-form-item label="小程序受理推送备注"  prop="program_note">
                        <el-input class="handle-input1" v-model="tableData.program_note" @change="addData(tableData.program_note,'program_note')"></el-input>
                    </el-form-item>
                       <el-form-item label="小程序取件通知"  prop="program_take">
                        <el-input class="handle-input1" v-model="tableData.program_take" @change="addData(tableData.program_take,'program_take')"></el-input>
                    </el-form-item>
                       <el-form-item label="小程序受理推送业务内容"  prop="program_business">
                        <el-input class="handle-input1" v-model="tableData.program_business" @change="addData(tableData.program_business,'program_business')"></el-input>
                    </el-form-item>
                </el-form>
                </div>
            </div>
            <div class="handlebox">
                <span class="boxFont">其他</span>
            </div>
            <div class="content" >
                <el-form label-width="180px" ref="tableData" :model="tableData" >
                    <el-form-item label="小程序二维码："  prop="program_code">
                        <img class="picerweima" v-if="tableData.program_code !=null" :src="tableData.program_code" alt=""></img>
                        <el-button type="success" @click="editVisiable=true">编辑小程序二维码</el-button>
                    </el-form-item>
                </el-form>
            </div> -->
        </div>
        <!-- 添加弹出框 -->
        <el-dialog title="添加管理员" :visible.sync="addVisiable" width="500px">
            <el-form ref="addForm" :rules="rules" :model="addForm" label-width="100px">
                <el-form-item label="管理员名称" prop="admin_name">
                    <el-input v-model="addForm.admin_name"></el-input>
                </el-form-item>
                <el-form-item label="OpemID" prop="admin_openID">
                    <el-input v-model="addForm.admin_openID"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisiable = false">取 消</el-button>
                <el-button type="primary" @click="addManage()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="编辑二维码" :visible.sync="editVisiable" width="500px">
            <el-form ref="editform" :rules="rules" :model="editform" label-width="100px">
                <el-form-item label="二维码" prop="pic">
                    <el-upload :limit="1" action="http://localhost:9999/cat/adopt/insertAdopt" ref="uploadimg"
                        list-type="picture-card" :auto-upload="false" :data="editform" :file-list="editform.pic"
                        :on-remove="handleRemove" :on-change="handleChange" :http-request="uploadFile">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisiable = false">取 消</el-button>
                <el-button type="primary" @click="editPic()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        fetchData
    } from '../../../api/index';
    import {
        post
    } from '../../../api/request';
    export default {
        name: 'basetable',
        data() {
            return {
                tableManage: [],
                editVisiable: false,
                rules: {
                    admin_name: [{
                        required: true,
                        message: '请输入管理名称',
                        trigger: 'blur'
                    }, ],
                    admin_openID: [{
                        required: true,
                        message: '请输入管理员OpenId',
                        trigger: 'change'
                    }, ],
                },
                addForm: {
                    admin_name: '',
                    admin_openID: ''
                },
                addVisiable: false,

                editform: {
                    pic: []
                },
                companyid: '',
                abc: '',
                query: {
                    address: '',
                    name: '',
                    pageIndex: 1,
                    pageSize: 10
                },
                tableData: {},
                editFrom: [],
                multipleSelection: [],
                delList: [],
                editVisible: false,
                pageTotal: 0,
                form: {},
                idx: -1,
                id: -1,
                fileList: [],
                formdata: ''
            };
        },
        created() {
            this.companyid = sessionStorage.getItem('companyid')
            this.getData();

        },
        activated() {
            this.companyid = sessionStorage.getItem('companyid')
            this.getData();

        },

        methods: {
            handleChange(file, fileList) {
                this.addForm.seal_pic = fileList;
            },
            handleRemove(file, fileList) {
                this.addForm.seal_pic = fileList;
            },
            uploadFile(file) {
                this.formdata.append('program_code', file.file);
            },
            editPic() {
                this.formdata = new FormData()
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
                this.formdata.append('company_id', this.companyid)
                this.$refs.uploadimg.submit();
                this.$refs['editform'].validate((valid) => {
                    if (valid) {
                        post("/admin/set/updateset", this.formdata).then(res => {
                            this.$refs['editform'].resetFields();
                            this.editVisiable = false
                            this.getData()
                        })
                    }
                })
            },
            deleteManage(index, row) {
                let formdata = new FormData()
                formdata.append('id', row.id)
                post("admin/set/deladmin", formdata).then(res => {
                    if (res.data.msg == " 删除成功") {
                        this.$message.success(" 删除成功")
                        this.getData()
                    }
                })
            },
            addManage() {
                this.$refs['addForm'].validate((valid) => {
                    if (valid) {
                        let formdata = new FormData()
                        let json1 = []
                        json1.push(this.addForm)
                        var json = JSON.stringify(json1)
                        formdata.append("company_id", this.companyid)
                        formdata.append('ret', json)
                        post("admin/set/insadmin", formdata).then(res => {
                            if (res.data.msg == " 添加成功") {
                                this.addVisiable = false
                                this.$refs['addForm'].resetFields();
                                this.$message.success("添加成功")
                                this.getData()
                            }
                        })
                    }
                })
            },
            addWork(list) {
                list.push({
                    admin_name: '',
                    admin_openID: ''
                })
            },
            // 删除属性列
            removeRow(index, list) {
                list.splice(index, 1)
            },
            // 获取 easy-mock 的模拟数据
            getData() {
                let formdata = new FormData()
                formdata.append("company_id", this.companyid)
                post('admin/set/selectset', formdata).then(res => {
                    this.tableManage = res.data.data.admin
                    this.tableData = res.data.data.set[0]
                })
            },
            addData(data, str) {
                let formdata = new FormData()
                formdata.append('company_id', this.companyid)
                formdata.append(str, data)
                post("admin/set/updateset", formdata).then(res => {
                    if (res.data.msg == "修改成功") {
                        this.$message.success("修改成功")
                    }
                })
            },
            // 触发搜索按钮
            handleSearch() {
                this.$set(this.query, 'pageIndex', 1);
                this.getData();
            },
            // 删除操作
            handleDelete(index, row) {
                // 二次确认删除
                this.$confirm('确定要删除吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.$message.success('删除成功');
                    this.tableData.splice(index, 1);
                }).catch(() => {});
            },
            // 多选操作
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            delAllSelection() {
                const length = this.multipleSelection.length;
                let str = '';
                this.delList = this.delList.concat(this.multipleSelection);
                for (let i = 0; i < length; i++) {
                    str += this.multipleSelection[i].name + ' ';
                }
                this.$message.error(`删除了${str}`);
                this.multipleSelection = [];
            },
            // 编辑操作
            handleEdit(index, row) {
                this.idx = index;
                this.form = row;
                this.editVisible = true;
            },
            // 保存编辑
            saveEdit() {
                this.editVisible = false;
                this.$message.success(`修改第 ${this.idx + 1} 行成功`);
                this.$set(this.tableData, this.idx, this.form);
            },
            // 分页导航
            handlePageChange(val) {
                this.$set(this.query, 'pageIndex', val);
                this.getData();
            },
        }
    };
</script>

<style scoped>
    .abc {
        width: 100%;
        height: 50px;
    }


    .boxFont {
        font-size: 20px;
        margin-left: 80px;
    }

    .handlebox {
        width: 100%;
        background: rgb(159, 201, 255);
        height: 50px;
        border-radius: 5px;
        display: flex;
        line-height: 50px;
        margin-bottom: 15px;

    }

    .picerweima {
        width: 150px;
        height: 150px;
        border-radius: 50%;
    }

    .print {
        width: 100%;
        background: rgb(251, 251, 252);
        border-radius: 5px;
        margin-bottom: 50px;
    }

    .installcontent {
        width: 800px;
        margin-left: 20%;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }

    .handle-input1 {
        width: 430px;
        display: inline-block;
    }

    .handle-input2 {
        width: 360px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }

    .inputPrint {
        width: 100px;
    }
</style>